const firebase = require("firebase/app")
require("firebase/firestore")


const format_date = (date, format) => {
  format = format.replace(/yyyy/g, date.getFullYear()-2000);
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
  return format
}


const create_random_list_id = () => {
  const date = new Date()
  const timestamp = format_date(date, 'yyyyMMddHHmmss')
  const random_number = Math.floor(Math.random()*9999)
  const random_number_str = ('0000' + random_number).slice(-4)  // 数値が4桁未満の場合0埋めする
  const list_id = timestamp + random_number_str
  return list_id
}


const create_mylist = async (firebase_uid, mylist_name) => {
  const list_id = create_random_list_id()
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const doc = await user_db.get()
  let user_info = doc.data()
  await db.collection("mylist").doc(list_id).set({
    list_name: mylist_name,
    create_user_id: user_info.twitter_id,
    create_user_name: user_info.twitter_name,
    tweets: []
  })
  const list_info_str = `${list_id},${mylist_name}`
  await user_db.update({
    create_list: firebase.firestore.FieldValue.arrayUnion(list_info_str)
  })
  console.log('create list ', list_id, mylist_name)
  return list_id
}


const delete_mylist = async (firebase_uid, mylist_id) => {
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const doc = await user_db.get()
  let user_info = doc.data()
  const list_infos = user_info.create_list.filter((info) => {
    const list_id = info.split(",")[0]
    return list_id != mylist_id
  })
  await user_db.update({ create_list: list_infos })
  await db.collection("mylist").doc(mylist_id).delete()
  console.log('delete list ', mylist_id)
  return true
}


const add_followlist = async (firebase_uid, followlist_id) => {
  const listinfo = await get_list_info(followlist_id).catch(e => {
    console.error(e)
    return {}
  })
  const follow_list_name = listinfo["list_name"]
  const create_user_id = listinfo["create_user_id"]
  const create_user_name = listinfo["create_user_name"]
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const list_info_str = `${followlist_id},${follow_list_name},${create_user_name},${create_user_id}`
  await user_db.update({
    follow_list: firebase.firestore.FieldValue.arrayUnion(list_info_str)
  })
  console.log('follow list ', followlist_id, follow_list_name, create_user_id, create_user_id)
  return listinfo
}


const remove_followlist = async (firebase_uid, followlist_id) => {
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const doc = await user_db.get()
  let user_info = doc.data()
  const list_infos = user_info.follow_list.filter((info) => {
    const list_id = info.split(",")[0]
    return list_id != followlist_id
  })
  await user_db.update({ follow_list: list_infos })
  console.log('remove list ', followlist_id)
  return true  
}


const get_mylist = async (firebase_uid) => {
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const doc = await user_db.get()
  const user_info = doc.data()
  let create_lists = []
  if('create_list' in user_info){
    create_lists = user_info.create_list.map((list_info)=>{
      const list_id = list_info.split(",")[0]
      const list_name = list_info.split(",")[1]
      return {list_id, list_name}
    })
  }
  let follow_lists = []
  if('follow_list' in user_info){
    follow_lists = user_info.follow_list.map((list_info)=>{
      const list_id = list_info.split(",")[0]
      const list_name = list_info.split(",")[1]
      const create_user = list_info.split(",")[2]
      const create_user_id = list_info.split(",")[3]
      return {list_id, list_name, create_user, create_user_id}
    })
  }
  return [create_lists, follow_lists]
}


const add_tweet_to_list = async (list_id, tweet_id) => {
  const db = firebase.firestore()
  db.collection("mylist").doc(list_id).update({
    tweets: firebase.firestore.FieldValue.arrayUnion(tweet_id)
  })
  .then(()=>{
    console.log(`add ${tweet_id} to ${list_id}`)
    return true
  })
}

const remove_tweet_from_list = async (list_id, tweet_id) => {
  const db = firebase.firestore()
  db.collection("mylist").doc(list_id).update({
    tweets: firebase.firestore.FieldValue.arrayRemove(tweet_id)
  })
  .then(()=>{
    return true
  })
}

const change_stock_name = async (list_id, new_list_name) => {
  const db = firebase.firestore()
  await db.collection("mylist").doc(list_id).update({
    list_name: new_list_name
  })
  console.log("change list name", list_id, new_list_name)
  return true
}


/**
 * @brief firestoreからリストの情報を得る
 * @param {String} list_id 
 * @return リストデータ 例) {create_user_id:"interimadd", create_user_name:"みがわり", list_name:"雑学", tweets:["1234", ...]}
 */
const get_list_info = async (list_id) => {
  const db = firebase.firestore()
  const list_db = db.collection("mylist").doc(list_id)
  const doc = await list_db.get()
  return doc.data()
}

module.exports = {create_mylist, delete_mylist, add_followlist, remove_followlist,
                  get_mylist, add_tweet_to_list, remove_tweet_from_list, get_list_info,
                  change_stock_name}


if (require.main === module) {
  (async()=>{
    const firebaseConfig = {
      apiKey: "AIzaSyAASJEBUfLvuNgiLn5Qk-8b2LNEwnHkNaY",
      authDomain: "twistock.firebaseapp.com",
      databaseURL: "https://twistock.firebaseio.com",
      projectId: "twistock",
      storageBucket: "twistock.appspot.com",
      messagingSenderId: "99223105259",
      appId: "1:99223105259:web:9fcd5f1be586b37ab658ae",
      measurementId: "G-369RF0P6PP"
    }
    const uid = "Wa6iMMTEqLSWS931aufXlnrN34C2"
    firebase.initializeApp(firebaseConfig)
    // リストの作成の例
    const followListId = "2008042341418302"
    const mylist_id = await create_mylist(uid, "自分のリスト")
    await add_followlist(uid, followListId)
    const [create_lists, follow_lists] = await get_mylist(uid)
    console.log(create_lists, follow_lists)
    await delete_mylist(uid, mylist_id)
    await remove_followlist(uid, followListId)
  })()
}